import script from "./ListGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ListGroup.vue?vue&type=script&setup=true&lang=js"

import "./ListGroup.vue?vue&type=style&index=0&id=3a5b508c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a5b508c"]])

export default __exports__